<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headerloi01" class="chapter" epub:type="frontmatter" id="loi">
<header id="headerloi01">
<h1 class="ctfm"><span aria-label="xi" class="page" id="pxi" role="doc-pagebreak"></span><a class="xref" href="#/chilie0007#toc">Figures</a></h1>
</header>
<p class="tocill"><a class="xref" href="#/chilie0013#fig1"><span class="fighn">1</span>   </a>Advertisement for <i>Manouche</i>: <i>Les musiques d’aujourd’hui des Tsiganes d’Alsace</i> (1984)</p>
<p class="tocill"><a class="xref" href="#/chilie0016#fig2"><span class="fighn">2</span>   </a>Postcard for the 2004 Festival Gipsy Swing</p>
<p class="tocill"><a class="xref" href="#/chilie0016#fig3"><span class="fighn">3</span>   </a>Ceremony at the grave of Django Reinhardt, Samois-sur-Seine, 1 July 2012</p>
<p class="tocill"><a class="xref" href="#/chilie0016#fig4"><span class="fighn">4</span>   </a>Map of the Festival Jazz Manouche de Zillisheim</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-lie-0009.vue?f55322c8